/**
 * Generated Contract Version
 * Do not edit manually.
 */
export const CONTRACT_HASH = '368f678c9596c551';
export const BUILD_TIMESTAMP = 1768935175771;
//# sourceMappingURL=version.js.map